module.exports = __webpack_public_path__ + "img/gamcare.9ec75c67.png";